module.exports = __webpack_public_path__ + "f057775935dcf2da36dc3b4c62870da2.MP3";